import { getExamCoveragePillProps } from '../medicalExams/examCatalogListDisplay';
import { CARE_REFERRAL_CATEGORIES } from '../../../constants/careReferralCategories';

export const REFERRAL_TAB_SHORT = {
  [CARE_REFERRAL_CATEGORIES.HOSPITAL_REFERRAL.id]: 'Hôpital',
  [CARE_REFERRAL_CATEGORIES.OPHTHALMOLOGY.id]: 'Ophtalmo',
  [CARE_REFERRAL_CATEGORIES.PEDIATRICS.id]: 'Pédiatrie',
  [CARE_REFERRAL_CATEGORIES.OPTICAL.id]: 'Lunettes'
};

export { getExamCoveragePillProps as getReferralCoveragePillProps };

/**
 * Ligne secondaire : partenaire, métadonnées, description (SMIE/CMC toujours en badge).
 */
export function buildReferralListSecondaryLine(item, categoryConfig) {
  const parts = [];

  if (item.partner_name) {
    parts.push(item.partner_name);
  }

  if (categoryConfig?.metadataFields) {
    categoryConfig.metadataFields.forEach((field) => {
      const value = item.metadata?.[field.key];
      if (value) parts.push(String(value));
    });
  }

  if (item.description?.trim()) {
    parts.push(item.description.trim());
  }

  return parts.join(' · ');
}
